import React, {ReactNode} from "react";
import {Button, Typography} from "@mui/material";
import {styled} from "@mui/material/styles";
import {FlexBox} from "@contents/components/customStyledComponent";
import {Strings} from "@app/constants/strings";
import LabelSimpleMobileComp from "@contents/mobile/layoutPages/components/LabelSimpleComp";

const CardWrap = styled(FlexBox)(
    ({ theme }) => ({
        width: '100%',
        flexDirection: 'column',
        backgroundColor: theme.palette.eliga_6FA.main,
        borderRadius: '18px',
        padding: '20px'
    })
);

interface BackgroundCardMobileCompProps {
    title?: string | ReactNode;
    children: ReactNode;
}

const BackgroundCardMobileComp = ({title, children} : BackgroundCardMobileCompProps) => {

    return (
        <CardWrap $column gap={'20px'}>
            <Typography variant={'subtitle1'} sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} color={'eliga_777.main'}>{title}</Typography>
            {children}
        </CardWrap>
    )
}

export default BackgroundCardMobileComp;
